<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="900" scrollable>
      <v-card>
        <v-card-title class="text-h5">
          Seleccionar Producto
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-text-field
            v-model="buscador"
            placeholder="Ejemplo: Arduino, Crema, Tablero"
            outlined
            class="mt-2"
          >
            <template v-slot:label>
              <v-icon style="vertical-align: middle">mdi-magnify</v-icon>
              Búsqueda por nombre de Producto
            </template>
          </v-text-field>

          <v-simple-table fixed-header>
            <template v-slot:default>
              <thead class="thead-dark">
                <tr>
                  <th>ID</th>
                  <th>Descripción</th>
                  <th>Cantidad Total</th>
                  <th>PVU</th>
                  <th>Seleccionar</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="producto in productosFiltrados" :key="producto.id">
                  <td>{{ producto.id }}</td>
                  <td>{{ producto.descripcion }}</td>
                  <td>{{ producto.cantidad_total }}</td>
                  <td>{{ producto.pvu }}</td>
                  <td>
                    <v-btn small color="primary" outlined @click="seleccionar(producto)">
                      <v-icon left small>mdi-check</v-icon>
                      Seleccionar
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import productoService from '@/services/tienda/productoService';

export default {
  name: 'ProductosDialogVenta',

  data() {
    return {
      dialog: false,
      buscador: '',
      productos: []
    };
  },

  computed: {
    productosFiltrados() {
      return this.productos.filter(p =>
        p.descripcion.toLowerCase().includes(this.buscador.toLowerCase())
      );
    }
  },

  methods: {
    openDialog() {
      this.dialog = true;
      this.buscador = '';
      this.listarProductos();
    },

    cerrar() {
      this.dialog = false;
      this.buscador = '';
    },

    seleccionar(producto) {
      this.$emit('seleccionado', producto);
      this.dialog = false;
      this.buscador = '';
    },

    listarProductos() {
      productoService.listarProductos()
        .then(res => { this.productos = res.data; })
        .catch(() => { console.error('Error al cargar productos'); });
    }
  }
};
</script>
